import React from "react";
import Smart from "../../../assets/images/touch.png";

const AppCli = () => {
    return(
        <div className="container">
            <div className="row">
                <h1>Aplicativo Gigabyte Cliente</h1>
                <div className="col-sm-12 col-md-4">
                    <img src={Smart} alt="foto" />
                </div>
                <div className="col-sm-12 col-md-8">
                    
                </div>
            </div>
        </div>
    )
}
export default AppCli;